import { type PropsWithChildren, useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

import { usePendingOrganization } from '@/hooks/usePendingOrganization'

const AUTH_PATH = '/auth'

export function PendingOrganizationGate({ children }: PropsWithChildren): JSX.Element | null {
  const navigate = useNavigate()
  const location = useLocation()
  const { isLoaded, isPending, requiresOrganization, role } = usePendingOrganization()

  const isAuthRoute = location.pathname === AUTH_PATH

  useEffect(() => {
    if (!isLoaded) return
    if (!requiresOrganization || !isPending) return
    if (isAuthRoute) return

    const params = new URLSearchParams({
      mode: 'signup',
      role: role === 'gcc' ? 'gcc' : 'provider',
      next: `${location.pathname}${location.search}${location.hash}`
    })

    navigate(`${AUTH_PATH}?${params.toString()}`, { replace: true })
  }, [isLoaded, isPending, isAuthRoute, location.hash, location.pathname, location.search, navigate, requiresOrganization, role])

  if (!isLoaded) return null
  if (isPending && !isAuthRoute) return null

  return <>{children}</>
}

